import { render } from "./DeploymentList.vue?vue&type=template&id=1f274c5f"
import script from "./DeploymentList.vue?vue&type=script&lang=js"
export * from "./DeploymentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__